
/**
 * Module dependencies.
 */

import { UserType } from 'src/types/user';
import { isAccessGranted } from 'src/core/utils/session';
import { useAuth } from 'src/context/auth/context';
import React, { ReactElement, ReactNode, useMemo } from 'react';

/**
 * `Props` type.
 */

type Props = {
  children: ReactNode,
  userTypePermission: UserType[]
};

/**
 * `Permission` component.
 */

const Permission = (props: Props): ReactElement | null => {
  const { children, userTypePermission } = props;
  const { isAuthenticated, user } = useAuth();
  const hasPermission = useMemo(() => {
    const userType = user?.user?.type;

    return isAuthenticated && isAccessGranted(userTypePermission, userType);
  }, [isAuthenticated, user, userTypePermission]);

  if (!hasPermission) {
    return null;
  }

  return (
    <>
      {children}
    </>
  );
};

/**
 * Export `Permission` component.
 */

export default Permission;
